import React, {Component} from 'react';
import {Link} from "react-router-dom";
import Footer from '../Footer';

class SummerDashPage extends Component<{},{}>{

    constructor(props: any){
        super(props);
          this.state = {
              
          };
      }

      render(){
          return (
              <div id="summer-dash">
                 <header>
                    <ul>
                        <li><Link to="/Home">Home</Link></li>
                        <li><Link to="/PrivacyPolicy">Privacy Policy</Link></li>
                        <li><Link to="/AboutUs">About Us</Link></li>
                        <li><Link className="selected" to="/SummerDash">Summer Dash</Link></li>
                    </ul>
                </header>
                <body>
                    <div className="section">  
                        <div className="summerdash">Summer Dash (ends 9/30/21)</div>
                        <iframe height="360" width="640"  
                        src="https://www.youtube.com/embed/407yeu_dUhI">
                        </iframe>
                        <p>Compete with your friends for a $1000 prize pool.</p>
                        <p>Top ten will win cash prize!</p>

                        <ul className="distribution"> Prize Distribution:
                            <li>1st: $200</li>
                            <li>2nd: $180</li>
                            <li>3rd: $150</li>
                            <li>4th: $100</li>
                            <li>5th: $90</li>
                            <li>6th: $80</li>
                            <li>7th: $70</li>
                            <li>8th: $60</li>
                            <li>9th: $40</li>
                            <li>10th: $30</li>
                        </ul>

                        <p>*Make sure you sign up with a email and are over 13 years old to qualify for the tournament*</p>
                    </div>
                </body>
                <Footer></Footer>
              </div>
          )
      }
}

export default SummerDashPage;